"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateApplicationsCommand = void 0;
const AbstractCommand_1 = require("../AbstractCommand");
class UpdateApplicationsCommand extends AbstractCommand_1.AbstractCommand {
    constructor(api, appId) {
        super(api);
        this.updates = {};
        this.withName = (name) => {
            this.updates.name = name;
            return this;
        };
        this.withDescription = (description) => {
            this.updates.description = description;
            return this;
        };
        this.withDefinition = (def) => {
            this.updates = { ...this.updates, ...def };
            return this;
        };
        this.appId = appId;
    }
    async exec() {
        await this.api.put(`/applications/${this.appId}`, this.updates);
    }
}
exports.UpdateApplicationsCommand = UpdateApplicationsCommand;
//# sourceMappingURL=UpdateApplicationsCommand.js.map